export type OperationalBasePrices = {
  hourlyRate?: number;
  truckT7?: number;
  truck6m?: number;
  truck12m?: number;
};

export type OperationalBasePricing = {
  location: string;
  hourlyRate: number;
  trucks: Array<{ key: string; price: number | '' | null }>;
};

export type OperationalBaseAgencyOption = {
  value: string;
  pricing?: OperationalBasePricing[];
};

const getOperationalBasePrices = (
  operationalBase: string | undefined,
  agencyId: string | undefined,
  agencies: OperationalBaseAgencyOption[] | undefined,
  transportTrucks: { type?: string; maxSize?: string } | undefined,
): OperationalBasePrices => {
  const prices: OperationalBasePrices = {};
  const base = agencies
    ?.find((agency) => agency.value === agencyId)
    ?.pricing
    ?.find((pricing) => pricing.location === operationalBase);

  if (!base) {
    return prices;
  }

  if (base.hourlyRate) {
    prices.hourlyRate = base.hourlyRate;
  }

  const transportType = transportTrucks?.type;
  const maxSize = transportTrucks?.maxSize;
  if (!base.trucks?.length || !transportType) {
    return prices;
  }

  const transportPrice6m = base.trucks.find((truck) => {
    if (truck.key === 'PL-6M' && transportType === 'sans grue') {
      return true;
    }
    if (truck.key === 'PL-6MG' && transportType === 'avec grue') {
      return true;
    }
    return false;
  })?.price;

  if (typeof transportPrice6m === 'number') {
    prices.truck6m = transportPrice6m;
  }

  const transportPriceT7 = base.trucks.find((truck) => (
    truck.key === 'T7-max-12T' && transportType === 'sans grue'
  ))?.price;

  if (typeof transportPriceT7 === 'number') {
    prices.truckT7 = transportPriceT7;
  }

  const transportPrice12m = base.trucks.find((truck) => {
    if (truck.key === 'PL-13M' && transportType === 'sans grue') {
      return true;
    }
    if (truck.key === 'PL-12-MG' && transportType === 'avec grue') {
      return true;
    }
    return false;
  })?.price;

  if (typeof transportPrice12m === 'number' && maxSize === '12m') {
    prices.truck12m = transportPrice12m;
  }

  return prices;
};

export default getOperationalBasePrices;
